// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.moveable-line {
  position: absolute;
  width: 1px;
  height: 1px;
  background: #fe6100 !important;
  transform-origin: 0px 0.5px; }

.moveable-control {
  width: 8px !important;
  height: 8px !important;
  border-radius: 0px !important;
  background-color: white !important;
  border: 1px solid #fe6100 !important;
  margin-top: -4px !important;
  margin-left: -4px !important; }

.coordinates,
.coordinatesScale {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 20px;
  height: 20px;
  background: rgba(255, 123, 41, 0.5);
  color: #ffffff;
  font-weight: 400;
  font-size: 8px;
  line-height: 9px;
  cursor: pointer; }
  .coordinates:hover,
  .coordinatesScale:hover {
    border: 1px solid #fe6100; }

.coordSelected {
  border: 1px solid #fe6100; }

.coordinatesZone {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 20px;
  height: 20px;
  color: #ffffff;
  font-weight: 400;
  font-size: 8px;
  line-height: 9px;
  pointer-events: none;
  border: 1px solid #fe6100; }
`, "",{"version":3,"sources":["webpack://./src/pages/inventory/components/EditInventoryModal/moveable.scss"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,8BAA8B;EAC9B,2BAA2B,EAAA;;AAE7B;EACE,qBAAqB;EACrB,sBAAsB;EACtB,6BAA6B;EAC7B,kCAAkC;EAClC,oCAAoC;EACpC,2BAA2B;EAC3B,4BAA4B,EAAA;;AAE9B;;EAEE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,mCAAmC;EACnC,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,eAAe,EAAA;EAZjB;;IAcI,yBAAyB,EAAA;;AAG7B;EACE,yBAAyB,EAAA;;AAE3B;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,yBAAyB,EAAA","sourcesContent":[".moveable-line {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  background: #fe6100 !important;\n  transform-origin: 0px 0.5px;\n}\n.moveable-control {\n  width: 8px !important;\n  height: 8px !important;\n  border-radius: 0px !important;\n  background-color: white !important;\n  border: 1px solid #fe6100 !important;\n  margin-top: -4px !important;\n  margin-left: -4px !important;\n}\n.coordinates,\n.coordinatesScale {\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  width: 20px;\n  height: 20px;\n  background: rgba(255, 123, 41, 0.5);\n  color: #ffffff;\n  font-weight: 400;\n  font-size: 8px;\n  line-height: 9px;\n  cursor: pointer;\n  &:hover {\n    border: 1px solid #fe6100;\n  }\n}\n.coordSelected {\n  border: 1px solid #fe6100;\n}\n.coordinatesZone{\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  width: 20px;\n  height: 20px;\n  color: #ffffff;\n  font-weight: 400;\n  font-size: 8px;\n  line-height: 9px;\n  pointer-events: none;\n  border: 1px solid #fe6100;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
